import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./Recent_update.css";
import Common_Title_1 from "../../common/common_components/common_title_1/Common_Title_1";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AllBlog } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

const Recent_update = () => {
  const sliderdata = [
    {
      image: "/assets/images/gurudev/baba.png",
      name: "Open Monitoring",
    },
    {
      image: "/assets/images/gurudev/baba.png",
      name: "Open Monitoring",
    },
    {
      image: "/assets/images/gurudev/baba.png",
      name: "Open Monitoring",
    },
    {
      image: "/assets/images/gurudev/baba.png",
      name: "Open Monitoring",
    },
    {
      image: "/assets/images/gurudev/baba.png",
      name: "Open Monitoring",
    },
  ];

  const dispatch = useDispatch();
  const all_blogs = useSelector((state) => state.common.all_blogs);

  useEffect(() => {
    dispatch(AllBlog());
  }, [dispatch]);

  return (
    <>
      <section className="recent_update_sec">
        <div className="container">
          <Common_Title_1 subText="Recent Updates" />

          <div className="slidersection">
            <Swiper
              slidesPerView={1}
              spaceBetween={30}
              loop={true}
            //   pagination={{
            //     clickable: true,
            //   }}
              // navigation={true}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              modules={[ Autoplay]}
              breakpoints={{
                0: {
                  slidesPerView: 1.2,
                  spaceBetween: 10,
                },
                575: {
                  slidesPerView: 2.5,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                991: {
                  slidesPerView: 3,
                  spaceBetween: 15,
                },
              }}
              className="mySwiper"
            >
              {all_blogs?.map((data, index) => (
                <SwiperSlide>
                  <Link to={`/meditation-blog-details/${data?.Blog?.id}`}>
                    <div className="slider_card" key={index}>
                      <img
                        className="babaimg"
                        src={IDS.IMG_URL + data?.Blog?.image}
                        alt={data?.name}
                      />
                      <div className="overlaycolor"></div>
                      <div className="textoverlay">
                        {/* <h6 className='medname'>{data.name}</h6> */}
                        <h6 className="medname">{data.name}</h6>
                      </div>
                    </div>
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
};

export default Recent_update;
